import classnames from 'classnames'

export interface CountProps {
  count: number
  customClass?: string
}

const Count = ({ count, customClass }: CountProps) => (
  <div className={classnames('instant-search__results-count', customClass)}>{count}</div>
)

export default Count
